export class InvestmentProducts {
    init () {
        var self = {
            selectors: {
                productLoader: "#productLoader",
                investmentsPage: "#investmentsPage",
                productsSection: "#investmentsProductsSection",
                sortBtn: ".investment-products__sort",
                sortAsc: "asc",
                sortAscClassName: "investment-products__sort--asc",
                sortDesc: "desc",
                sortDescClassName: "investment-products__sort--desc"
            },
            loadData: function () {
                $(self.selectors.productsSection).hide();
                $(self.selectors.productLoader).show()

                var $section = $(self.selectors.investmentsPage);
                var url = $section.attr('data-url');

                // get selected ordering
                var searchParams = new URLSearchParams(window.location.search)
                var currentOrdering = searchParams.get("ordering");
                currentOrdering = currentOrdering !== null && currentOrdering.length > 0 ? currentOrdering : 'title';

                $.ajax({
                    url: url,
                    type: 'GET',
                    data: {
                        ordering: currentOrdering
                    },
                    success: function (res) {
                        $(self.selectors.productsSection).show().html(res.html);
                    },
                    complete: function () {
                        $(self.selectors.productLoader).hide();
                    }
                });
            },
            setUrlQueryParam: function (ordering) {
                // Set query param in URL
                var searchParams = new URLSearchParams(window.location.search)
                searchParams.set("ordering", ordering);
                // Save new URL in browser history without page reload
                var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
                history.pushState(null, '', newRelativePathQuery);
            },
            toggleActiveClass: function ($this) {
                $(self.selectors.sortBtn).removeClass('active');
                $this.addClass('active');
            },
            toggleOrdering: function ($this) {
                var currentSort = $this.attr('data-sort');
                self.setDefaultParams();

                if (! $this.hasClass('active')) {
                    return;
                }

                if (self.selectors.sortAsc === currentSort) {
                    $this.removeClass(self.selectors.sortAscClassName).addClass(self.selectors.sortDescClassName)
                    $this.attr('data-ordering', '-' + $this.attr('data-ordering'));
                    $this.attr('data-sort', self.selectors.sortDesc);
                } else {
                    $this.removeClass(self.selectors.sortDescClassName).addClass(self.selectors.sortAscClassName)
                    $this.attr('data-ordering', $this.attr('data-base-ordering'));
                    $this.attr('data-sort', self.selectors.sortAsc);
                }
            },
            setDefaultParams() {
                $(self.selectors.sortBtn).removeClass(self.selectors.sortDescClassName).addClass(self.selectors.sortAscClassName);
                $(self.selectors.sortBtn).attr('data-sort', self.selectors.sortAsc);

                $(self.selectors.sortBtn).each(function () {
                    var baseValue = $(this).attr('data-base-ordering');
                    $(this).attr('data-ordering', baseValue);
                });
            }
        };

        $(self.selectors.sortBtn).click(function () {
            self.toggleOrdering($(this))
            self.setUrlQueryParam($(this).attr('data-ordering'))
            self.toggleActiveClass($(this))
            self.loadData()
        });

        if ($(self.selectors.investmentsPage).length > 0 && typeof $(self.selectors.investmentsPage) !== 'undefined') {
            self.loadData()
        }
    }
}